import './animateheight.scss'

import {MediaQuery} from '@codeurs/front'
import React, {Fragment, FunctionComponent, useState} from 'react'
import AnimateHeight, {AnimateHeightProps} from 'react-animate-height'
import {DropdownArrowIcon} from 'styles/inline-icons'
import {Theme} from 'views/campagne/theme'
import {style} from './campagne/style'

const styles = style('animateheight')
export const AnimateHeightOnlyMobile: FunctionComponent<AnimateHeightProps> = ({
	title,
	children,
	...props
}) => {
	const [isOpen, setOpen] = useState(false)

	return (
		<Fragment>
			<MediaQuery
				maxWidth={1023}
				view={() => (
					<div class={styles}>
						<Theme.Container>
							<div class={styles('title')} onClick={() => setOpen(!isOpen)}>
								<Theme.H3>{title}</Theme.H3>
								<DropdownArrowIcon
									className={styles('title-arrow')
										.is({open: isOpen})
										.toString()}
								/>
							</div>
						</Theme.Container>
						<AnimateHeight
							duration={500}
							{...props}
							height={isOpen ? 'auto' : 0}
						>
							{children}
						</AnimateHeight>
					</div>
				)}
			/>
			<MediaQuery {...props} minWidth={1024} view={() => children} />
		</Fragment>
	)
}
